import { memo, useEffect, useState } from "react";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { fetchFormDetails } from "js/Api/forms";
import QuestionsManagement from "./components/QuestionsManagement";
import Settings from "./Settings";
import Responses from "./Responses";
import ResponsesList from "./ResponsesList";

const FormDetails = (props) => {
    const { handleBackClick, org, selectedForm } = props;

    const [selectedTab, setSelectedTab] = useState("Settings");
    const [reLoadData, setreLoadData] = useState(false);
    const [formDetailsObj, setFormDetailsObj] = useState(null);
    const [selectedResponse, setSelectedResponse] = useState(null);
    const [formResponse, setformResponse] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const isTemplate = selectedForm?.templateType === "recurring" ? true : (selectedForm?.isTemplate || false);

    const handleBackToDetails = () => {
        setSelectedResponse(null);
    };

    const fetchFormDetailsHandler = async () => {
        if (!selectedForm?.id) return;

        setIsLoading(true);
        try {
            const response = await fetchFormDetails(selectedForm.id);
            if (response?.success && response?.data) {
                setFormDetailsObj(response.data);
                setformResponse([]);

                if (response.data?.responses?.length > 0) {
                    setformResponse(response.data?.responses.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
                }
            }
        } catch (error) {
            console.error("Error fetching form details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFormDetailsHandler();
    }, [selectedForm?.id, reLoadData]);

    const [formDirty_Settings, setformDirty_Settings] = useState(false);

    const handleTabClick = (tab) => {
        if (formDirty_Settings) {
            const confirmSwitch = window.confirm(
                'You have unsaved changes. Are you sure you want to switch tab?'
            );
            if (confirmSwitch) {
                setSelectedTab(tab);

                if (tab !== "Responses") {
                    setSelectedResponse(null);
                }
                setformDirty_Settings(false); // Reset unsaved changes flag
            }
        } else {
            setreLoadData(prev => !prev);
            setSelectedTab(tab);

            if (tab !== "Responses") {
                setSelectedResponse(null);
            }
        }
    };

    const handleBackToResponses = () => {
        setSelectedResponse(null);
    };

    const renderTabContent = () => {
        if (selectedResponse) {
            return (
                <ResponsesList selectedResponse={selectedResponse} onBack={handleBackToResponses} handleBackClick={handleBackToDetails} />
            );
        }

        switch (selectedTab) {
            case "Questions":
                return (
                    <QuestionsManagement formDetailsObj={formDetailsObj} org={org} onFormUpdate={fetchFormDetailsHandler} isLoading={isLoading} />
                );
            case "Settings":
                return (
                    <Settings org={org} formDetailsObj={formDetailsObj} refetchFormDetails={fetchFormDetailsHandler} isTemplate={isTemplate} formDirty_Settings={formDirty_Settings}
                        setformDirty_Settings={setformDirty_Settings} handleTabClick={handleTabClick} />
                );
            case "Responses":
                return (
                    <Responses org={org} setSelectedResponse={setSelectedResponse} responsesList={formResponse} setreLoadData={setreLoadData} />
                );
            case "Form Instances":
                return (
                    <Responses org={org} setSelectedResponse={setSelectedResponse} responsesList={formResponse} setreLoadData={setreLoadData} isTemplate={true} />
                );
            default:
                return null;
        }
    };

    const getAvailableTabs = () => {
        if (isTemplate) {
            return ["Settings", "Questions", "Form Instances"];
        } else {
            return ["Settings", "Questions", "Responses"];
        }
    };

    const availableTabs = getAvailableTabs();

    return (
        <div className="midde_cont">
            <div
                className="container-fluid"
                style={{ paddingLeft: "0", paddingRight: "0" }}
            >
                <div className="row column_title">
                    <div className="col-md-12">
                        <div
                            className="page_title"
                            style={{ display: "flex", alignItems: "center" }}
                        >
                            <ArrowBackRoundedIcon
                                onClick={handleBackClick}
                                sx={{
                                    fontSize: "2rem",
                                    color: "black",
                                    marginRight: "10px",
                                    cursor: "pointer",
                                }}
                            />
                            <h2 style={{ flex: "1" }}>
                                {formDetailsObj?.formName || "Loading..."}
                                {isTemplate && " (Template)"}
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="white_shd full margin_bottom_30">
                    <div className="full inner_elements">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="padding_infor_info">
                                    {!selectedResponse && (
                                        <div className="tabbar" style={{ marginBottom: "20px" }}>
                                            <nav>
                                                <div
                                                    className="nav nav-tabs"
                                                    id="nav-tab"
                                                    role="tablist"
                                                >
                                                    {availableTabs.map((tab) => (
                                                        <div key={tab} className={`nav-item nav-link ${selectedTab === tab ? "active" : ""}`} onClick={() => handleTabClick(tab)} >
                                                            {tab}
                                                        </div>
                                                    ))}
                                                </div>
                                            </nav>
                                        </div>
                                    )}

                                    <div>
                                        {renderTabContent()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(FormDetails);